import StorageAbstractFactory from '@infrastructure/cache';

export default function onReditectTo(navigate, dispatch) {
  return function (path) {
    const storage = StorageAbstractFactory.getSyncGlobalInstance();
    const hasToken = storage.getItem('token');
    if (!!hasToken) navigate(path);
    else {
      dispatch('token-not-found');
      navigate('/login');
    }
  };
}
